import Component from 'flarum/common/Component';
import Button from 'flarum/common/components/Button';
import Carousel from 'hero-carousel';
import LogInModal from 'flarum/forum/components/LogInModal';

export default class HeaderSlideShowView extends Component {
  oninit(vnode) {
    super.oninit(vnode);

    this.bodyClass = 'App--page';
    this.loading = true;
    this.categories = [];
    this.carousel;

    this.currentHeadSlideShow = app.data.currentHeadSlideShow;
    

    // app.store.find('headSlideShow'
    // // ,{ filter: { pkgId: app.session.pkgLogo.id() } }
    // )
    // .then((res) => {
    //   this.categories = app.store
    //     .all('headSlideShowCategories')
    //     .filter((headSlideShow) => (headSlideShow.pkgId = app.data.pkgLogo.id))
    //     .sort((a, b) => a.id() - b.id());
    //     this.currentHeadSlideShow = this.categories[0];
    //   this.loading = false;
    //   m.redraw();
    // });
  }
  oncreate(){
    this.carousel = new Carousel(document.querySelector('.carousel'), this.currentHeadSlideShow.transitionTime * 1000) || 5000;
  }
  view() {
    // const categories = this.currentHeadSlideShow;
    let category = this.currentHeadSlideShow;
    
    let objOne = null;
    let mapOne = new Map();
    let imageOne = '';
    let imageTwo = '';
    let imageThree = '';
    let imageFour = '';
    let imageFive = '';
    let objOnePc = '';
    if (category) {
      if (app.store.models.type != 'phone') {
        objOne = JSON.parse(category.imageOne);
        mapOne = new Map(Object.entries(objOne));
        objOnePc = mapOne.get('pc');
        imageOne = objOnePc[app.data.locale];

        objOne = JSON.parse(category.imageTwo);
        mapOne = new Map(Object.entries(objOne));
        objOnePc = mapOne.get('pc');
        imageTwo = objOnePc[app.data.locale];

        objOne = JSON.parse(category.imageThree);
        mapOne = new Map(Object.entries(objOne));
        objOnePc = mapOne.get('pc');
        imageThree = objOnePc[app.data.locale];

        objOne = JSON.parse(category.imageFour);
        mapOne = new Map(Object.entries(objOne));
        objOnePc = mapOne.get('pc');
        imageFour = objOnePc[app.data.locale];

        objOne = JSON.parse(category.imageFive);
        mapOne = new Map(Object.entries(objOne));
        objOnePc = mapOne.get('pc');
        imageFive = objOnePc[app.data.locale];
      } else {
        objOne = JSON.parse(category.imageOne);
        mapOne = new Map(Object.entries(objOne));
        objOnePc = mapOne.get('phone');
        imageOne = objOnePc[app.data.locale];

        objOne = JSON.parse(category.imageTwo);
        mapOne = new Map(Object.entries(objOne));
        objOnePc = mapOne.get('phone');
        imageTwo = objOnePc[app.data.locale];

        objOne = JSON.parse(category.imageThree);
        mapOne = new Map(Object.entries(objOne));
        objOnePc = mapOne.get('phone');
        imageThree = objOnePc[app.data.locale];

        objOne = JSON.parse(category.imageFour);
        mapOne = new Map(Object.entries(objOne));
        objOnePc = mapOne.get('phone');
        imageFour = objOnePc[app.data.locale];

        objOne = JSON.parse(category.imageFive);
        mapOne = new Map(Object.entries(objOne));
        objOnePc = mapOne.get('phone');
        imageFive = objOnePc[app.data.locale];
      }
    }
    const centerOnClick = (event) => {
      // if (!app.session.user) {
      //   event.preventDefault();
      //   app.modal.show(LogInModal);
      //   return;
      // }
    };
    
    let url = app.forum.attribute('baseUrl');
    return (
      <div className="carousel">
        <Button className="carousel__left__btn" aria-label="left" onclick={() => this.carousel.prevSlide()}>
          <img src={`${app.data.pkgLogo.cdnUrl}/${app.data.pkgLogo.ossFile}/img-lbtuqh.png`}></img>
        </Button>
        <div className="carousel__slides" tabindex="0">
          <div className="carousel__slide image-placeholder">
            {this.loading && category && category.imageOne && (
              <a onclick={centerOnClick} href={category.linkOne ? (category.linkOne && (category.linkOne.includes('http') ? category.linkOne : url + category.linkOne)) : '#'}>
                <img class="carousel__slide-image lazy" onload={function(){
                  this.classList.remove('lazy')
                  this.classList.add('lazy-loaded')
                  }} src={imageOne} />
              </a>
            )}
          </div>
          <div className="carousel__slide image-placeholder">
            {this.loading && category && category.imageTwo && (
              <a onclick={centerOnClick} href={category.linkTwo ? (category.linkTwo && (category.linkTwo.includes('http') ? category.linkTwo : url + category.linkTwo)) : '#'}>
                <img class="carousel__slide-image lazy" onload={function(){
                  this.classList.remove('lazy')
                  this.classList.add('lazy-loaded')
                  }} src={imageTwo} />
              </a>
            )}
          </div>

          <div className="carousel__slide image-placeholder">
            {this.loading && category && category.imageThree && (
              <a onclick={centerOnClick} href={category.linkThree ? (category.linkThree && (category.linkThree.includes('http') ? category.linkThree : url + category.linkThree)) : '#'}>
                <img class="carousel__slide-image lazy" onload={function(){
                  this.classList.remove('lazy')
                  this.classList.add('lazy-loaded')
                  }} src={imageThree} />
              </a>
            )}
          </div>
          <div className="carousel__slide image-placeholder">
            {this.loading && category && category.imageFour && (
              <a onclick={centerOnClick} href={category.linkFour ? (category.linkFour && (category.linkFour.includes('http') ? category.linkFour : url + category.linkFour)) : '#'}>
                <img class="carousel__slide-image lazy" onload={function(){
                  this.classList.remove('lazy')
                  this.classList.add('lazy-loaded')
                  }} src={imageFour} />
              </a>
            )}
          </div>
          <div className="carousel__slide image-placeholder">
            {this.loading && category && category.imageFive && (
              <a onclick={centerOnClick} href={category.linkFive ? (category.linkFive && (category.linkFive.includes('http') ? category.linkFive : url + category.linkFive)) : '#'}>
                <img class="carousel__slide-image lazy" onload={function(){
                  this.classList.remove('lazy')
                  this.classList.add('lazy-loaded')
                  }} src={imageFive} />
              </a>
            )}
          </div>
        </div>
        <Button className="carousel__right__btn" aria-label="left" onclick={() => this.carousel.nextSlide()}>
          <img src={`${app.data.pkgLogo.cdnUrl}/${app.data.pkgLogo.ossFile}/img-lbtuqh.png`}></img>
        </Button>
        <div className="carousel__controls"></div>
      </div>
    );
  }
}
